import AuthenticatedFlyout from './AuthenticatedFlyout';

export default AuthenticatedFlyout;
